import React, { Dispatch, SetStateAction } from 'react';
import { Box } from '@mui/material';
import { Done as DoneIcon, Edit as EditIcon } from '@mui/icons-material';
import { classes } from './styles';

export default function NewJobSidebar({
  currentStep,
  setCurrentStep,
  fromApproval,
  setError
}: {
  currentStep: number;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  fromApproval?: boolean;
  setError: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <Box sx={{ width: '25%', padding: '60px 0', borderRight: '#DDDDDD 1px solid' }}>
      <Box id="new-job-modal-title" sx={classes.modalHeader}>
        {fromApproval ? 'Create new job from approval' : 'Create new job'}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
        <Box sx={{ display: 'flex', padding: '30px 0' }}>
          <Box>
            <Box sx={classes.verticleLineWhite} />
            <Box sx={{ display: 'flex' }}>
              <Box sx={classes.stepNumberGreen}>1</Box>
              <Box sx={{ paddingLeft: '0.5rem' }}>
                <Box sx={{ fontWeight: '700', color: '#666666' }}>
                  New Job{' '}
                  {currentStep > 1 ? (
                    <DoneIcon sx={{ fontSize: '18px', color: '#76D18F' }} />
                  ) : (
                    <span />
                  )}
                </Box>
                {currentStep !== 1 && currentStep > 1 ? (
                  <Box
                    sx={classes.editStep}
                    onClick={() => {
                      setCurrentStep(1);
                      setError(false);
                    }}
                  >
                    Edit <EditIcon sx={{ fontSize: '12px', marginBottom: '3px' }} />
                  </Box>
                ) : (
                  <span />
                )}
              </Box>
            </Box>
            <Box sx={classes.verticleLine} />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', padding: '30px 0' }}>
          <Box>
            <Box sx={classes.verticleLine} />
            <Box sx={{ display: 'flex', opacity: currentStep > 1 ? 1 : 0.4 }}>
              <Box sx={currentStep > 1 ? classes.stepNumberGreen : classes.stepNumberGrey}>2</Box>
              <Box sx={{ paddingLeft: '0.5rem' }}>
                <Box sx={{ fontWeight: currentStep > 1 ? '700' : 'inherit', color: '#666666' }}>
                  Job Details{' '}
                  {currentStep > 2 ? (
                    <DoneIcon sx={{ fontSize: '18px', color: '#76D18F' }} />
                  ) : (
                    <span />
                  )}
                </Box>
                {currentStep !== 2 && currentStep > 1 ? (
                  <Box sx={classes.editStep} onClick={() => setCurrentStep(2)}>
                    Edit <EditIcon sx={{ fontSize: '12px', marginBottom: '3px' }} />
                  </Box>
                ) : (
                  <span />
                )}
              </Box>
            </Box>
            <Box sx={classes.verticleLine} />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', padding: '30px 0' }}>
          <Box>
            <Box sx={classes.verticleLine} />
            <Box sx={{ display: 'flex', opacity: currentStep > 2 ? 1 : 0.4 }}>
              <Box sx={currentStep > 2 ? classes.stepNumberGreen : classes.stepNumberGrey}>3</Box>
              <Box
                sx={{
                  paddingLeft: '0.5rem',
                  fontWeight: currentStep > 2 ? '700' : 'inherit',
                  color: '#666666'
                }}
              >
                Review
              </Box>
            </Box>
            <Box sx={classes.verticleLineWhite} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
